
import { LocalStorageService } from 'angular-web-storage';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { TopbarService } from 'src/app/core/topbar/topbar.service';
import { LoginService } from '../../login/login.service';

import { Component, OnInit } from '@angular/core';
import { IParamsCollection } from 'src/app/core/jsonapi/interfaces/params-collection';
import { firstValueFrom } from 'rxjs';
import { FilterBuilder } from 'src/app/core/jsonapi/filters-builder';
import { Filter, FilterOperation } from 'src/app/core/jsonapi/filter';
import { ReportsService } from '../_services/reports.service';
import { ReportsUsersGroupsPermissionsListComponent } from '../detail/reports-users-groups-permissions-list/reports-users-groups-permissions-list.component';
import { DialogService } from 'primeng/dynamicdialog';

@Component({
    selector: 'app-reports-list',
    templateUrl: './reports-list.component.html',
    host: { class: 'list-page' },
    standalone: false
})
export class ReportsComponent implements OnInit{
  
  public reports: any = [];
  public totalRecords: number = 0;
  public loading: boolean = false;
  private lastGridEvent: any = {
    first: 0,
    rows: 0
  };
  public filters: any = {
    name: new Filter(FilterOperation.contains, 'name'),
  };
  public allowWrite: boolean = false;
  public allowDelete: boolean = false;
  public type: string = "";

  constructor(
    private storage: LocalStorageService,
    private messageService: MessageService,    
    private confirmationService: ConfirmationService,                
    private router: Router,
    private topbarService: TopbarService,
    public loginService: LoginService,
    private reportsService: ReportsService,
    private route: ActivatedRoute,
    private dialogService: DialogService
  ) {
  }

  ngOnInit(): void {        

    this.route.paramMap.subscribe((params: ParamMap) => {      
      this.topbarService.setTitle("Informes");   
      this.topbarService.addAction("Nuevo", "pi pi-plus", false, () => {
        this.edit();
      });
    });
    this.allowWrite = this.loginService.hasPermission("REPORTS.WRITE");
    this.allowDelete = this.loginService.hasPermission("REPORTS.DELETE");
    
  }

  async loadData($event: any) {
    
    this.lastGridEvent = $event;

    let params:IParamsCollection = {      
      include: ["dataset", "createdByUser"],
      page: { number: $event.first+1, size: $event.rows },            
      sort: ['name'],
      filter: FilterBuilder.fromObject(this.filters).build()
    }            
    
    if(typeof $event.sortField != "undefined") params.sort = [($event.sortOrder > 0 ? "-" : "") + $event.sortField];


    let response = await firstValueFrom(this.reportsService.all(params));
    this.reports = response.data;
    this.totalRecords = response.meta['total'];
    this.topbarService.setCount(this.totalRecords);
  }
  
  clearFilters() {
    this.filters = {};
    this.search();
  }

  search() {
    this.lastGridEvent.first = 0;
    this.loadData(this.lastGridEvent);
  }

  edit() {
    //if (this.loginService.hasPermission("REPORTS_WRITE")) {      
      this.router.navigate(['reports/'+0]);
    //}
  }

  visualization(report: any) {
    //if (this.loginService.hasPermission("REPORTS_WRITE")) {      
      this.router.navigate(['reports/visualization/'+ (report && Object.keys(report).length > 0 ? report.id : 0)]);
    //}
  }

  delete(report: any) {    
    if (this.allowDelete) {      
      this.confirmationService.confirm({
        message: "¿Está seguro que desea eliminar el informe "+report.name+"?",
        header: "Eliminar informe",
        acceptLabel: "Aceptar",
        rejectLabel: "Cancelar",
        acceptButtonStyleClass: "p-button-danger",
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
          this.reportsService.delete(report.id).subscribe({
            next: (data: any) => {
              this.messageService.add({ closable: true, severity: 'success', detail: "Informe eliminado correctamente" });
              this.loadData(this.lastGridEvent);
            },
            error: (error: any) => {
              this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
            }
          });
        },
        reject: (error: any) => {
          this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
        }
      });
    }
  }

  permissions(report: any){
    var dialog = this.dialogService.open(ReportsUsersGroupsPermissionsListComponent, {
          closable: true,
          modal: true,
          header: 'Dar permisos a '+report.name,
          width: '50%',
          data: {
            report: report
          }
        });
        dialog.onClose.subscribe(async (result:any) => {
          //this.loadTransaction(this.transaction.id!);
        });
  }
  
}
